import { Component, OnInit, NgZone, Input, ViewChild, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras, RoutesRecognized } from '@angular/router';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { ToastService } from 'src/app/services/toast.service';
import { IonSlides, Platform } from '@ionic/angular';
import { ActionSheetController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';
import { StoreService } from 'src/app/services/store.service'
import { UserService } from 'src/app/services/user.service'
import { element } from 'protractor';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-website-home',
  templateUrl: './website-home.page.html',
  styleUrls: ['./website-home.page.scss'],
})
export class WebsiteHomePage implements OnInit {
  //Configuration for each Slider
  slideOptsOne = {
    initialSlide: 0,
    slidesPerView: 1,
    autoplay: true
  };
  slideOptsTwo = {
    initialSlide: 1,
    slidesPerView: 2,
    loop: true,
    centeredSlides: true,
    spaceBetween: 20
  };
  slideOptsThree = {
    initialSlide: 0,
    slidesPerView: 5
  };

  userAddress: string = ''
  userLatitude: string = ''
  userLongitude: string = ''
  addressDisplay: any;
  showText: boolean;
  cart: any = [];
  qty: number = 1;
  show: any;
  @Input() item;
  limit = 500;
  offset: any = 0;
  loading: boolean = false;
  a: boolean = false;
  public subscription: any;
  address: string;
  latitude: number;
  longitude: number;
  accuracy: number;
  productListB: any
  // userId: any = localStorage.getItem('userId');
  bannerImg: any;
  responsiveOptions;
  merChat: any;
  offerResponse: any;
  productList: any;
  productListA: any;
  middleImgbottom: any;
  storeInfo: any;
  locationFlag: any;
  page_number: any;
  city = localStorage.getItem('city');
  pin: any;
  allShipAddArr: any;
  recommendedProducts: any;
  recommend1: boolean;
  flag: any;
  skipRole: any;
  changeText: boolean;
  AppName: String;
  productListApi: any = []
  slideOptions = {
    initialSlide: 2,
    slidesPerView: 1,
    autoplay: true,
    speed: 300,
    loop: true
  };
  slideOptions2 = {
    initialSlide: 1,
    slidesPerView: 1,
    autoplay: true,
    speed: 400,
  };
  catslideOptions1 = {
    initialSlide: 1,
    slidesPerView: 2.5,
    autoplay: false,
  };

  offersslideOptions = {
    initialSlide: 0,
    slidesPerView: 3,
    loop: true
  };
  slideOpts = {
    initialSlide: 1,
    slidesPerView: 3,
    speed: 400
  };
  category: any;
  isLoading: boolean;
  noDataImage: boolean;
  productFound: boolean;
  count: number;
  check: boolean;
  searchResultData: string;
  product = ['Amul', 'Axe', 'Bambino', 'Bikano', 'Bingo', 'Boost', 'Bournvita', 'Britannia', 'Brook-bond', 'Bru', 'Cadbury', 'Cinthol',
    "Closeup", "Colgate", "Dabur", "Del-monte", "Dettol", "Dove", "Everest", "G-fresh", "Garnier", "Gillette", "Glucon-D", "Godrej", "Gowardhan",
    "Grocery", "Hajmola", "Haldiram's", "head and shoulders", " Heinz", " Hershey's", "Himalaya", "Horlicks", "India-gate", "Kellogg's",
    "Kinley", "Kissan", "Knorr", " Lay's", "Lifebouy", "Lijjat", "Limca", "Lipton", " L'Oreal", "Madhur", "Maggi", "McCain", "MDH", "Minute-maid",
    " Mother-Diary", "Mountain Dew", "move", "MTR", "Nescafe", "Nestle", "Nivea", "Nuttela", "Oral-B", "Oreo", "Pantene", "Paper Boat",
    "Parachute", "Parle", "Patanjali", "Pears", "Pepsodent", "Rajdhani", "Real", "Red Bull", "Shakti Bhog", "Smith", "Sprite", "Stayfree",
    "Sundrop", "Sunfeast", "Sunsilk", "Taj Mahal", "Tang", "Tata Tea", "Thumps Up", "Tops", "Tropicana", "Uncle-Chipps", "Unibic", "Vasline",
    "Veet", "Vicks", "vlcc facial kit", " Wagh Bakri", " Wai-wai", "Whisper", "Mantra"
  ]
  productListC: any;
  productListD: any;
  productListE: any;
  productListF: any;
  productListG: any;
  productListH: any;
  productListI: any;
  productListJ: any;
  productListK: any;
  isItemAvailable: boolean;
  str1: any;
  googlemap: any;
  ipaddress: any;
  addedToWishlist: any;
  productId: any;
  userId: string;
  _id: any;
  userId_id: any;
  user_id: any;
  deleteProduct: any;
  selectedId: any;
  Product: any;
  n: any;
  products: any;
  productJuice: any[];


  constructor(
    private toast: ToastService,
    private ngZone: NgZone,
    private router: Router,
    private routerActivate: ActivatedRoute,
    private service: StoreService,
    private appVersion: AppVersion,
    private platform: Platform,
    public actionSheetController: ActionSheetController,
    public alertController: AlertController,
    public userService: UserService,
    private _platform: Platform, private toastService: ToastService,public title: Title, public meta: Meta,private renderer: Renderer2
  ) {
    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 5,
        numScroll: 5
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 2
      },
      {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1
      }
    ];
    this.changeText = false;
 //Item object for Nature
 this.title.setTitle("SpotYourDeal: One-stop Shopping Destination for Grocery, Mobiles, Electronics & More");
 this.meta.addTags([
     { name: "description", content: "Shop a wide range of products including grocery, mobiles, electronics, home and kitchen items, personal care products, toys and games, TVs & appliances, pet care, and more at SpotYourDeal. Enjoy up to 40% off on women's and men's personal care, watches, household care, and footwear. Find daily needs, atta, edible oil, tea, coffee, rice, and other grains. Discover electrical and electronic appliances, lights, air conditioners, mixer grinders, smart TVs, combo offers, home and kitchen essentials, furniture, toys, games, and chocolates. SpotYourDeal is the ultimate e-commerce destination for all your shopping needs with irresistible prices and convenient online shopping experience." },
     { name: "keywords", content: "Grocery, Mobiles, Electronics, Home and kitchen, Personal Care, Toys and Games, TVs & Appliances, Pet Care, Watches, Household Care, Footwear, Clothing, Bags, Daily Needs, Atta & Other Flours, Edible Oil, Tea, Coffee & Drinks, Rice & Other Grains, Electrical and Electronic Appliances, Lights, Air Conditioners, Mixer Grinder, Smart Tv, Combo Offers, Furniture, Chocolates, SpotYourDeal, E-commerce, Online shopping, Popular Categories, Popular Brands, Amul, Axe, Bambino, Bikano, Bingo, Boost, Bournvita, Britannia, Brook-bond, Bru, Cadbury, Cinthol, Closeup, Colgate, Dabur, Del-monte, Dettol, Dove, Everest, G-fresh, Garnier, Gillette, Glucon-D, Godrej, Gowardhan, Hajmola, Haldiram's, Head and Shoulders, Heinz, Hershey's, Himalaya, Horlicks, India-gate, Kellogg's, Kinley, Kissan, Knorr, Lay's, Lifebouy, Lijjat, Limca, Lipton, L'Oreal, Madhur, Maggi, McCain, MDH, Minute-maid, Mother-Diary, Mountain Dew, MTR, Nescafe, Nestle, Nivea, Nutella, Oral-B, Oreo, Pantene, Paper Boat, Parachute, Parle, Patanjali, Pears, Pepsodent, Rajdhani, Real, Red Bull, Shakti Bhog, Smith, Sprite, Stayfree, Sundrop, Sunfeast, Sunsilk, Taj Mahal, Tang, Tata Tea, Thumps Up, Tops, Tropicana, Uncle-Chipps, Unibic, Vaseline, Veet, Vicks, VLCC facial kit, Wagh Bakri, Wai-wai, Whisper, Mantra." },
      // Meta robots
      { name: "robots", content: "index,follow" },
      // OG Tag Facebook
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://spotyourdeal.com" },
      { property: "og:title", content: "SpotYourDeal: One-stop Shopping Destination for Grocery, Mobiles, Electronics & More" },
      { property: "og:description", content: "Shop a wide range of products including grocery, mobiles, electronics, home and kitchen items, personal care products, toys and games, TVs & appliances, pet care, and more at SpotYourDeal. Enjoy up to 40% off on women's and men's personal care, watches, household care, and footwear. Find daily needs, atta, edible oil, tea, coffee, rice, and other grains. Discover electrical and electronic appliances, lights, air conditioners, mixer grinders, smart TVs, combo offers, home and kitchen essentials, furniture, toys, games, and chocolates. SpotYourDeal is the ultimate e-commerce destination for all your shopping needs with irresistible prices and convenient online shopping experience." },
      { property: "og:image", content: "https://firebasestorage.googleapis.com/v0/b/spotyourdeal-38ab2.appspot.com/o/productImages%2F1685014932974?alt=media&token=e3ed73fa-6083-407f-b136-2da958f7a3c6" },
      // Twitter Card
      { property: "twitter:url", content: "https://spotyourdeal.com" },
      { property: "twitter:title", content: "SpotYourDeal: One-stop Shopping Destination for Grocery, Mobiles, Electronics & More" },
      { property: "twitter:description", content: "Shop a wide range of products including grocery, mobiles, electronics, home and kitchen items, personal care products, toys and games, TVs & appliances, pet care, and more at SpotYourDeal. Enjoy up to 40% off on women's and men's personal care, watches, household care, and footwear. Find daily needs, atta, edible oil, tea, coffee, rice, and other grains. Discover electrical and electronic appliances, lights, air conditioners, mixer grinders, smart TVs, combo offers, home and kitchen essentials, furniture, toys, games, and chocolates. SpotYourDeal is the ultimate e-commerce destination for all your shopping needs with irresistible prices and convenient online shopping experience." },
      { property: "twitter:image", content: "https://firebasestorage.googleapis.com/v0/b/spotyourdeal-38ab2.appspot.com/o/productImages%2F1685014932974?alt=media&token=e3ed73fa-6083-407f-b136-2da958f7a3c6" },
     
  ]);
  }

  ngOnInit() {
    this.userService.appSettings.subscribe((resp: any) => {
      console.log("appSettings resp version ", resp.version);
      if (resp && resp.checkVersion && resp.version) {
        console.log("resp.version ", resp.version);
        this.appVersion.getVersionNumber().then(version => {
          console.log("this.appVersion.getVersionNumber() ", version);
          if (resp.version != version) {
          }
        });
      }
    })

    if (!localStorage.getItem('city')) {
      this.AddController();
    }
    this.fetchProductLimit();
    this.topBannerImage();
    this.middleBannerImage();

    this.city = localStorage.getItem('city')
    this.pin = localStorage.getItem('pin')
    // trending
    this.category = this.routerActivate.snapshot.params.category;
    // this.subCategory=this.routerActivate.snapshot.params.subCat;
    // if(this.subCategory==0){
    //   this.subCategory=""
    // }
    console.log(this.city)
    if (this.city != null && this.city != '') {
      localStorage.setItem('city', this.city);
    }
    if (this.pin != null && this.pin != '') {
      localStorage.setItem('pin', this.pin);
    }
    // this.storageService.get(AuthConstants.AUTH_USERDATA).then((data) => {
    //   this.userId = data
    // })

    this.city = localStorage.getItem('city');
    if (this.city != null) {
      this.locationFlag = 3;
    }
    this.pin = localStorage.getItem('pin')
    if (this.pin != null) {
      this.locationFlag = 2;
    }
   
    const value = localStorage.getItem('city');
    //  if (value){
    //   this.str1=value
    //   document.getElementById('modal-one').style.display='none'; 

    //  } 
    this.userId = localStorage.getItem('userId');
    this.userService.cartUpdated.subscribe(res => {
      let cart = localStorage.getItem('cart');
      if(cart){
        this.n = JSON.parse(cart).length;

    console.log("userService cartUpdated n", this.n)
      
    this.productId=localStorage.getItem("productId")
      }
    })
   this.ionViewWillEnter()
    const canonicalUrl = 'https://spotyourdeal.com'; // canonical URL
  
    const link = this.renderer.createElement('link');
    this.renderer.setAttribute(link, 'rel', 'canonical');
    this.renderer.setAttribute(link, 'href', canonicalUrl);
    this.renderer.appendChild(document.head, link);
  }
  ionViewWillEnter(){
    this.searchResultData = ""
    this.fetchWishlist()
    this.trendProduct()
    this.Chocolates()
    this.Toys()
    this.Juice()
  }
  async updateAlertConfirm() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Please update!',
      message: 'New version available with new features, security and bug fixes!',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          id: 'cancel-button',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Update!',
          id: 'confirm-button',
          handler: () => {
            window.location.assign('https://play.google.com/store/apps/details?id=com.spot.mckinsol')
            console.log('Confirm Okay');
          }
        }
      ]
    });

    await alert.present();
  }
  electronic() {
    this.router.navigate(['electronic-accessories'])
  }

  appliances() {
    this.router.navigate(['appliances'])
  }

  fetchProductLimit() {
    const proObj = {}
    this.service.webProductCat(proObj).subscribe((result: any) => {

      this.productListA = result.msg
      console.log(this.productListA)
    }, (error: any) => {
      this.toast.presentToast(error)
    });
  }
  topBannerImage() {
    this.service.topBannerImg().subscribe((result: any) => {
      console.log("Response banner image", result)
      this.bannerImg = result
      this.merchantCatList()
    }, (error: any) => {
      this.toast.presentToast(error)

    });
  }


  productDetail1(productItem: any) {
    console.log("hello hi ", productItem)
    this.router.navigate(['./product-detail/' + productItem._id])
  }

  merchantCatList() {
    this.service.preDifnedCat().subscribe((result: any) => {
      console.log("Response from merchandied catagories", result)
      this.merChat = result

    }, (error: any) => {
      this.toast.presentToast(error)
    });
  }
  ViewMoreProd(category: any, subCat: any) {
    console.log(subCat)
    if (subCat == '') {
      subCat = 0
    }
    console.log(subCat)
    this.router.navigate(['/product-list/' + category + '/' + subCat]);
  }

  search_Cat_Store() {

    this.router.navigate(['/search-cat-store-page'])
  }
  productDetail(productItem: any) {
    let qty = 1;
    console.log("product item object clickable product", productItem);
    let navigationParams: NavigationExtras = { state: { productId: productItem._id, promotionId: productItem.promotionId, productQty: qty } };
    this.router.navigate(['/product-detail'], navigationParams);
  }
  fetchStoreList(category: any, subCat: any) {
    console.log("product item object clickable product", category, subCat);
    let navigationParams: NavigationExtras = { state: { cat: category, subCat: subCat } };
    this.router.navigate(['/store-list'], navigationParams);
  }

  openProductDeal(productId: any, merchandiseCat: any, cityName: any, bannerOfferType: any, storeId: any, articleNumber: any, imageName: any) {
    if (bannerOfferType == "M5") {
      console.log("enter")
      this.router.navigate(['/referral-code']);
    } else if (bannerOfferType == "M6") {

      console.log("You are enter in M6 section", bannerOfferType)
      let navigationParams: NavigationExtras = { state: { cat: merchandiseCat, cityName: cityName, bannerOfferType: bannerOfferType, storeId: storeId } };
      this.router.navigate(['/home/promo-from-specific'], navigationParams);
    } else if (bannerOfferType == "M8") {

      console.log("You are enter in M6 section", bannerOfferType)
      let navigationParams: NavigationExtras = { state: { cat: merchandiseCat, cityName: cityName, bannerOfferType: bannerOfferType, storeId: storeId } };
      this.router.navigate(['/home/promo-from-specific'], navigationParams);
    } else if (bannerOfferType == "M7") {

      let navigationParams: NavigationExtras = { state: { productId: productId, cat: merchandiseCat, city: cityName, bannerOfferType: bannerOfferType, storeId: storeId, articleNumber: articleNumber, imageName: imageName } };
      this.router.navigate(['/today-offer'], navigationParams);
    } else {

      let navigationParams: NavigationExtras = { state: { productId: productId, cat: merchandiseCat, city: cityName, bannerOfferType: bannerOfferType, storeId: storeId } };
      this.router.navigate(['/today-offers'], navigationParams);
    }
  }

  wishlist() {
    this.router.navigate(['/wishlist'])
  }
  orderHistory() {
    this.router.navigate(['/order-history'])
  }
  cart1() {
    this.router.navigate(['/cart'])
  }

  loginmobile() {
    this.router.navigate(['/login'])
  }
 
 
  middleBannerImage() {
    let that = this;
    const DisObj = {
      city: this.city
    }
    this.service.middleBannerImg1(DisObj).subscribe((result: any) => {

      this.ngZone.run(() => {
        console.log("result ", result)
        that.middleImgbottom = result;
        console.log("that.middleImgbottom ", that.middleImgbottom)
      });

    }, (error: any) => {

    });
  }
  async AddController() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Choose Location',
      cssClass: 'action-search-custom-class',
      buttons: [
        // {
        //   text: 'Zip Code',
        //   icon: 'pin-outline',
        //   handler: () => {
        //     this.locationFlag = 2;
        //     this.page_number = 1;
        //     this.enterSerachkeyword(this.locationFlag)
        //     console.log('Share clicked');
        //   }
        // }, 
        {
          text: 'City',
          icon: 'business-outline',
          handler: () => {
            this.locationFlag = 3;
            this.page_number = 1;
            // this.enterSerachkeyword(this.locationFlag)
            this.enterCityRadio(this.locationFlag)
            console.log('Play clicked');
          }
        }
      ]
    });
    await actionSheet.present();

    const { role } = await actionSheet.onDidDismiss();
  }

  ////City radio button added by Parul
  async enterCityRadio(flag: number) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Select City',
      inputs: [
        {
          name: 'radio1',
          type: 'radio',
          label: 'Edison',
          value: 'Edison',
  
        },
        {
        name: 'radio1',
        type: 'radio',
        label: 'Kanpur',
        value: 'Kanpur',

      },
      {
        name: 'radio1',
        type: 'radio',
        label: 'Lucknow',
        value: 'Lucknow',
        // handler: () => {
        //   console.log('Radio 1 selected');
        // },
      },
      {
        name: 'radio1',
        type: 'radio',
        label: 'Delhi NCR',
        value: 'Delhi NCR',

      },
      ],
      buttons: [{
        text: 'Cancel',
        role: 'cancel',
        cssClass: 'secondary',
        handler: (blah) => {

          //  console.log('Confirm Cancel: blah');
        }
      }, {
        text: 'OK',
        handler: (data) => {
          if (flag == 3) {
            //flag use for enter "city" keyword
            this.productList = [];
            this.page_number = 1;
            localStorage.setItem('city', data);
            this.city = data;
            localStorage.setItem('pin', '');
            this.pin = null;
            console.log('Confirm flag == 3', this.city);
            this.recommendedProducts = [];
            this.middleBannerImage();
            //this.recommandedProductList();
          }
        }
      }]
    });

    await alert.present();
  } ////

  async enterSerachkeyword(flag: number) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Enter PIN Code',
      inputs: [{
        name: 'searchKeyword',
        type: 'number',
        placeholder: 'Please Enter here',
      },],
      buttons: [{
        text: 'Cancel',
        role: 'cancel',
        cssClass: 'secondary',
        handler: (blah) => {

          console.log('Confirm Cancel: blah');
        }
      }, {
        text: 'Okay',
        handler: (data) => {
          if (flag == 2) {
            this.productList = [];
            this.page_number = 1;
            this.pin = data.searchKeyword;
            localStorage.setItem('pin', this.pin);
            this.pin = data.searchKeyword;
            localStorage.setItem('city', '');
            this.city = null;
            console.log('Confirm flag == 2');

          }
        }
      }]
    });

    await alert.present();
  }

  fetchAllShippingAddress() {
    const formData = {
      userId: this.userId,
    }
    console.log("send by update customer address formData", formData)
    this.service.dfetchAllShipAddress(formData).subscribe((result: any) => {
      this.allShipAddArr = result[0].city
      if ((this.city == null || this.city == '') && (this.pin == null || this.pin == '')) {
        this.city = result[0].city
      }
      console.log("Response from fetch all Shipping Address api", result)
    }, (error: any) => { });
  }

  subCategory(cat: any, subCat: any) {
    // subCat = 0;
    this.router.navigate(['/grocery-store/' + cat + '/' + subCat],)

  }

  recommend() {
    let navigationParams: NavigationExtras = { state: { Reflag: 'recommend', city: this.city, pin: this.city } };
    this.router.navigate(['/recommend-product'], navigationParams);
  }
  onClick(productItem: any) {
    let qty = 1;
    let navigationParams: NavigationExtras = { state: { productId: productItem._id, promotionId: productItem.promotionId, productQty: qty, backPageFlag: { backPageFlagInfo: "6" } } };
    this.router.navigate(['/product-detail'], navigationParams);
  }

  // fetchCatStoreTerm() {
  //   let navigationParams: NavigationExtras = { state: { city: this.city, pin: this.pin, backPageFlag: { backPageFlagInfo: "H", city: this.city, pin: this.pin } } };
  //   this.router.navigate(['/search-product'], navigationParams);

  // }
  fetchCatStoreTerm1(event) {
    console.log(event)
    let navigationParams: NavigationExtras = { state: { product: event, city: this.city, pin: this.pin, backPageFlag: { backPageFlagInfo: "H", city: this.city, pin: this.pin } } };
    this.router.navigate(['/brand'], navigationParams);
  }

  async presentUpdateAppModal() {

    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'App-Update',
      message: 'Please update app to get the latest feature',
      buttons: [{
        text: 'Cancel',
        role: 'cancel',
        cssClass: 'secondary',
        handler: (blah) => {

        }
      }, {
        text: 'Update',
        handler: (data) => {
        }
      }]
    });

    await alert.present();

  }



  ///Added for search product
  // goBack() {
  //   this.navController.pop();
  // }

  // filter() {
  //   this.filterO = this.filterO * (-1)
  //   console.log(this.filterO)
  //   if (this.filterO == 1) {
  //     this.a = 10
  //   } else {
  //     this.a = 125;
  //   }
  // }
  options = {
    centeredSlides: true,
    loop: true,
    spaceBetween: -100,
  };
  option1 = {
    slidesPerView: 1.3,
    centeredSlides: true,
    loop: true,
    spaceBetween: -920,
    allowSlideNext: true,
    allowSlidePrev: true,
    // autoplay:true,
  }


  handleAddToCart(productObj) {
    let promoListobj = {
      productdetails: productObj,
      userId: this.userId
    }

    this.service.addToCart(promoListobj)
      .subscribe((result: any) => {
        this.toast.presentToast("Product added in your cart")
      }, (error: any) => {
      });
  }




  // onImageLoad(item){
  //   console.log("hii")
  //   item.image=true;
  //   this.loading=true;
  //   if(item.image==true){
  //     this.a='visible'
  //   }
  //   else{
  //     this.a='none'
  //   }
  // }

  handleMissingImage($event) {
    console.log($event)
    console.log("hello error");
    ($event.target as HTMLImageElement).style.display = 'none'
    this.a = true;
  }
  handleAddToCarta(productObj) {
    console.log("productObj ", productObj)

    this.cart = []
    if (productObj.qty) {///Added by Parul
      ++productObj.qty
    }
    else {
      productObj['qty'] = 1;
    }
    let cart = localStorage.getItem("cart");
    if (cart) {
      this.cart = JSON.parse(cart);
      console.log("cart ", this.cart)
      let filtered = this.cart.filter(product => product.id == productObj._id)
      console.log("filtered ", filtered)
      if (filtered.length == 0) {
        var pdata = {
          id: productObj._id,
          qty: this.qty
        }
        console.log(pdata)
        this.cart.push(pdata)
        localStorage.setItem('cart', JSON.stringify(this.cart))
        // this.show = 1
      } else {
        console.log(this.show)
        let index = this.cart.indexOf(filtered[0]);
        console.log("index ", index)
        this.cart[index]['qty'] = productObj.qty;//Added by Parul
        // this.cart.splice(index, 1)
        localStorage.setItem('cart', JSON.stringify(this.cart))
        // this.show = null

      }
    } else {
      console.log("item._id ", productObj._id)
      var pdata = {
        id: productObj._id,
        qty: this.qty
      }
      this.cart.push(pdata)
      localStorage.setItem('cart', JSON.stringify(this.cart))
      this.show = 1
    }
    this.userService.cartUpdated.next(true);
  }

  deleteFromCart(item) {
    if (item.qty > 0) {
      --item.qty;
      this.cart = []
      let cart = localStorage.getItem("cart");
      if (cart) {
        this.cart = JSON.parse(cart);
        console.log("cart ", this.cart)
        let filtered = this.cart.filter(product => product.id == item._id)
        let index = this.cart.indexOf(filtered[0])
        this.cart[index]['qty'] = item.qty;
        if (item.qty == 0) {
          this.cart.splice(index, 1)
        }
        localStorage.setItem('cart', JSON.stringify(this.cart))
        this.userService.cartUpdated.next(true);
      }
      // this.loadCartItems();

    }
  }
  isRetailer() {
    if (localStorage.getItem('retailerEnabled') == "1")
      return true;
  }

  // edit by vikash
  // search location api
  getItems(ev: any) {
    const val = ev.target.value;
    if (val && val.trim() !== '') {
      this.isItemAvailable = true;

      this.service.addressLookup({ value: val }).subscribe((data) => {
        this.googlemap = data;
        // console.log("ee",data)
        console.log("response google map", this.googlemap)
      })
    } else {
      this.isItemAvailable = false;
    }

  }

  // change(val) {
  //   console.log(val)
  //   this.str1 = val.split(',')[0];;
  //   localStorage.setItem('city', this.str1)
  //   this.middleBannerImage(this.str1)
  //   location.reload()
  // }
  // for wishlist add and remove icon
  // edit by vikash
  topDeals: boolean = false;
  topDealsProductWishList(prodId, index, product) {
    this.selectedId = index;
    this.topDeals = !this.topDeals;
    if (product.isSelect) {
      this.deleteWishlist(prodId, index, product)
    } else {
      this.AddToWishlist(prodId, index, product)
    }
  }

  // wishlist api
  // wishlist api
  AddToWishlist(proId: any, index: any, product) {
    // console.log(index, 'value..');
    // console.log(proId,product,'************')
    this.addedToWishlist = !this.addedToWishlist
    let user = localStorage.getItem("userId")
    let formdata = {
      userId: user,
      productId: proId
    }
    if(user=="undefined" || user==null) {
      console.log("login your account1 ")
      product.isSelect = false;
      this.router.navigate(['/login']);
    }
    else{
      console.log("user id is ", user);
      product.isSelect = true;
      console.log("id of user", formdata)
      this.service.addToWishlist1(formdata).subscribe(() => {
        //this.addedToWishlist = true;
        console.log("ADD WISH", this.addedToWishlist)
        this.toastService.presentToast("Added to your Wishlist")
      })
    }
    this.ionViewWillEnter1()
    this.fetchWishlist()
  }
  deleteWishlist(proId: any, index: any, product) {
    console.log(index, 'value..');
    let array = {
      userId: localStorage.getItem("userId"),
      productId: proId
    }
    let user = localStorage.getItem('userId');
    if(user=="undefined") {
      console.log("login your account1 ")
      product.isSelect = false;
      this.router.navigate(['/login']);
    }
    else {
      console.log("user id is12 ", user);
    product.isSelect = false;
    this.service.deleteWish(array).subscribe(() => {
      console.log("id of user1", array);
      // this.addedToWishlist=false;
      console.log("remove wish", this.addedToWishlist)
      this.toastService.presentToast("Removed from your Wishlist")
    })
  }
  this.ionViewWillEnter1()
  this.fetchWishlist()
}
fetchWishlist(){
  let array={
   userId:localStorage.getItem("userId")
  }
  this.service.fetchWishlist(array).subscribe((res)=>{
    this.Product=res;
    console.log(this.Product,'dta,..');
    this.isLoading=true;
  }
  )
}
Wishlist(proId:any){
 let array={
   userId:this.userId,
   productId:proId
 }
 
 this.service.deleteWish(array).subscribe((res)=>{
   console.log(res);
   this.deleteProduct=res;
   this.fetchWishlist()
 })
}
ionViewWillEnter1(){
  this.a=this.userService.uid;
  console.log(this.a,"Shraddha USer login firebase UID value a")
  if(this.a){
    this.check=true;
  }else{
    this.check=false
  }
  let data={
    uid : this.a
  }
  this.userService.getUserDetails(data).subscribe((res:any)=>{
    console.log("Login Account response",res);
    if(res){
      this.userId=res._id
      localStorage.setItem("userId", this.userId)
      console.log("dsfdg", this.userId)
    }
  })
}
trendProduct() {
  let formdata =
  {
    city: this.city
  }
  console.log("Response from formdata of productlist", formdata)
  this.service.bigSaving(formdata).subscribe((result) => {
    console.log("", result)
    this.products = result[0]

  })
}

trendingProduct() {
  console.log(this.products)
  localStorage.setItem('product', JSON.stringify(this.products['topoffers'][0]))
  this.router.navigate(['/top-deals']);
}
savingBig() {
  let formdata =
  {
    city: this.city
  }
  console.log("Response from formdata of productlist", formdata)
  this.service.bigSaving(formdata).subscribe((result) => {
    console.log("", result)
    this.products = result[0]
  })
}
saveBig() {
  console.log(this.products)
  localStorage.setItem('product', JSON.stringify(this.products['bigsaving'][0]))
  this.router.navigateByUrl('/bigsaving')
}
alloffer() {
  let formdata =
  {
    city: this.city
  }
  console.log("Response from formdata of productlist", formdata)
  this.service.bigSaving(formdata).subscribe((result) => {
    console.log("", result)
    this.products = result[0]

  })
}
productOffers() {
  console.log(this.products)
  localStorage.setItem('product', JSON.stringify(this.products['alloffers'][0]))
  this.router.navigateByUrl('/alloffers')

}

Chocolates() {
  var cart = JSON.parse(localStorage.getItem("cart"))
  this.productListK = [];
  let formdata =
  {cat: "Grocery", subcat: "Chocolates", limit: 600, offset: 0}
  console.log("Response from formdata of productlist", formdata)
  this.service.getProduct(formdata).subscribe((data) => {
    for (let i = 0; i < data.length; i++) {
      this.productListK.push(data[i]);
      var product = cart.filter((element: any)=>element.id==this.productListK[i]._id)[0]
      if(product)
      this.productListK[i]['qty'] = product.qty  
    }
  })
}
Toys() {
  var cart = JSON.parse(localStorage.getItem("cart"))
  this.productListH = [];
  let formdata =
    { cat: "Grocery", subcat: "Rice and & other Grains", limit: 12, offset: 0}
  console.log("Response from formdata of productlist", formdata)
  this.service.getProduct(formdata).subscribe((result) => {
    for (let i = 0; i < result.length; i++) {
         this.productListH.push(result[i]);
         var product = cart.filter((element: any)=>element.id==this.productListH[i]._id)[0]
         if(product)
         this.productListH[i]['qty'] = product.qty  
       }

  })
}
Juice() {
  var cart = JSON.parse(localStorage.getItem("cart"))
  this.productJuice = [];
  let formdata =
    { search: "Juice", limit: 12, offset: 0}
  console.log("Response from formdata of productlist", formdata)
  this.service.getProduct(formdata).subscribe((result) => {
    for (let i = 0; i < result.length; i++) {
         this.productJuice.push(result[i]);
         var product = cart.filter((element: any)=>element.id==this.productJuice[i]._id)[0]
         if(product)
         this.productJuice[i]['qty'] = product.qty  
       }

  })
}
navigateToAllProducts() {
  this.router.navigate(['all-products']);
}
categoryList(category: any) {
  this.router.navigate(['/category-list/' + category]);
}
}


